/**
 * Payload para `admin-actions` → `comunidad_ai_screen` (moderación asistida en admin).
 * @param {object} row — fila de `comunidad_publicaciones` (select habitual del panel).
 */
export function buildComunidadAiScreenPayload(row) {
  const c = row?.cuerpo && typeof row.cuerpo === 'object' ? row.cuerpo : {};
  return {
    publication_id: row.id,
    title: row.title ?? '',
    publicacion_tipo: row.publicacion_tipo ?? '',
    notas: c.notas != null ? String(c.notas) : '',
    maps_url: c.mapsUrl != null ? String(c.mapsUrl) : '',
    imagen_url: c.imagenUrl != null ? String(c.imagenUrl) : '',
    fecha: c.fecha != null ? String(c.fecha) : '',
    ciudad: c.ciudad != null ? String(c.ciudad) : '',
    fuente_url: row.fuente_url != null ? String(row.fuente_url) : '',
    fuente_fecha: row.fuente_fecha != null ? String(row.fuente_fecha) : '',
    external_key: row.external_key != null ? String(row.external_key) : '',
    metadata_source:
      row.metadata && typeof row.metadata === 'object' ? String(row.metadata.source ?? '') : '',
    entrada_tipo: row.entrada_tipo ?? null,
    entrada_precio: row.entrada_precio ?? null,
    entrada_enlace: row.entrada_enlace ?? '',
  };
}

/** Extrae mensaje legible cuando invoke devuelve HTTP 4xx/5xx. */
async function extractInvokeErrorMessage(error, data) {
  if (data?.message) return String(data.message);
  if (data?.error && data.error !== 'invoke_failed') return String(data.error);
  if (!error) return 'Error desconocido';
  let msg = error.message || 'Error';
  if (error.context && typeof error.context.json === 'function') {
    try {
      const j = await error.context.json();
      if (j?.message) return String(j.message);
      if (j?.error) return String(j.error);
    } catch (_) {
      /* ignore */
    }
  }
  if (msg === 'Edge Function returned a non-2xx status code') {
    return 'La función admin-actions rechazó la petición. Revisa que el workflow n8n esté activo y los secrets USER_REVIEW en Supabase.';
  }
  return msg;
}

/**
 * @param {*} supabase — cliente Supabase (sesión admin)
 * @param {object} row
 * @param {{ reviewContext?: 'n8n_borrador' | 'usuario_pendiente' }} [options]
 * @returns {Promise<{ ok: boolean, screening?: object, error?: string, message?: string }>}
 */
export async function invokeComunidadAiScreen(supabase, row, options = {}) {
  const payload = {
    ...buildComunidadAiScreenPayload(row),
    review_context: options.reviewContext ?? '',
  };
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: { action: 'comunidad_ai_screen', payload },
  });
  if (error) {
    const message = await extractInvokeErrorMessage(error, data);
    return { ok: false, error: data?.error || 'invoke_failed', message };
  }
  if (!data?.ok) {
    return { ok: false, error: data?.error || 'unknown', message: data?.message };
  }
  return { ok: true, screening: data.screening };
}
